const Client = ({ clients }) => {
  const _clients = clients.map(({ name, avatar, positions, testimonial }) => (
    <div className="item-testimonial col-md-6" key={testimonial}>
      <div className="testimonial-content">
        <h5>{testimonial}</h5>
      </div>

      <div className="testimonial-author">
        <div className="img-part">
          <img src={avatar} alt="client" />
        </div>

        <div className="testimonial-author-content">
          <h6>{name}</h6>
          <span>{positions}</span>
        </div>
      </div>
    </div>
  ));
  return (
    <section id="testimonial" className="testimonial section-padding">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="section-title-2">
              <div className="line"></div>
              <div className="text">
                <p>What our clients say</p>
                <h3>Testimonials</h3>
              </div>
            </div>
          </div>

          <div className="col-sm-12 client-info">
            <div className="carousel-slick">{_clients}</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Client;
